export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5265.18568379.jpg";